// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Recipient {
    static getAttributeTypeMap() {
        return Recipient.attributeTypeMap;
    }
}
Recipient.discriminator = undefined;
Recipient.additionalProperties = false;
Recipient.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    },
];
//# sourceMappingURL=recipient.js.map